import { useLocation } from "react-router-dom";
import styles from "./RecipesPage.module.css";
import { useNavigate } from "react-router-dom";
import {
  BreadCrumb,
  Banner,
} from "../../../components/shared";

const recipeData = [
  {
    id: 1,
    title: "Daily Immunity Support",
    description:
      "Support your immune system naturally with essential vitamins, herbal supplements, and antioxidant-rich wellness products designed for everyday protection and energy.",
    image:
      "https://cdn.pixabay.com/photo/2015/12/06/18/28/capsules-1079838_1280.jpg",
  },
  {
    id: 2,
    title: "Healthy Heart Care",
    description:
      "Maintain a healthy heart with omega supplements, balanced nutrition support, and pharmacist-recommended products that help improve cardiovascular wellness.",
    image:
      "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: 3,
    title: "Energy & Daily Wellness",
    description:
      "Stay active throughout your day with vitamins, minerals, hydration solutions, and wellness essentials carefully selected for complete body support.",
    image:
      "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?q=80&w=1200&auto=format&fit=crop",
  },
];

const RecipesPage = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];
  const navigate = useNavigate();
  return (
    <section className={styles.about__wrapper}>
      <BreadcrumbBanner
        newPath={newPath}
        heading="A recipe is a set of instructions for preparing a dish using specific ingredients and steps "
        imageUrl="https://cdn.pixabay.com/photo/2020/06/05/12/19/pill-5263028_1280.jpg"
      />

      {/* Intro Section */}
      <div className={styles.recipe__intro}>
       

        <h1 className={styles.main__heading}>
          Caring for Your Health Every Day
        </h1>

        <p className={styles.main__paragraph}>
          At VITAURA, we believe healthcare should be simple, accessible,
          and trustworthy. From vitamins and supplements to wellness products
          and prescription support, we provide high-quality healthcare solutions
          tailored to your everyday lifestyle.
        </p>
      </div>

      {/* Cards Section */}
      <div className={styles.cards__wrapper}>
        {recipeData.map((item, index) => (
          <div
            key={item.id}
            className={`${styles.card__section} ${
              index % 2 !== 0 ? styles.reverse : ""
            }`}
          >
            {/* Image */}
            <div className={styles.card__image}>
              <img src={item.image} alt={item.title} />
            </div>

            {/* Content */}
            <div className={styles.card__content}>
              <h2>{item.title}</h2>

              <p>{item.description}</p>

            <button
  onClick={() => window.open("/products_theory_report.pdf", "_blank")}
>
  More
</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "Recipes", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default RecipesPage;